export type ThemeColorType = keyof typeof ThemeColor;
export type ThemeShadesType = keyof typeof ThemeShades;

export enum ThemeColor {
  blue = 'blue',
  red = 'red',
  orange = 'orange',
  green = 'green',
  purple = 'purple',
  gray = 'gray',
}

export enum ThemeShades {
  light = 'light',
  dark = 'dark',
}

export enum ThemeColorClassTypes {
  Base = 'base',
  Border = 'border',
  Button = 'button',
}

export const getGradientClass = (color: ThemeColorType) => `theme-gradient-${color}`;

export const getThemeColorClass = (color: ThemeColorType, theme?: ThemeShadesType) =>
  theme ? `theme-${theme}-${color}` : `theme-${color}`;

export const getCustomThemeColorClass = (color: ThemeColorType, theme?: ThemeShadesType) => {
  const colorClass = color;
  const themeClass = theme ?? ThemeShades.dark;
  const classMap: Record<ThemeColorClassTypes, string> = {
    [ThemeColorClassTypes.Base]: `theme-${themeClass}-${colorClass}`,
    [ThemeColorClassTypes.Border]: `theme-border-${themeClass}-${colorClass}`,
    [ThemeColorClassTypes.Button]: `theme-${colorClass}`,
  };
  return classMap;
};
